import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'src/apis/apiService'
import { LIVE_SESSION_APIS } from 'src/apis/liveSessionApi'
import { CurrentUserType } from 'src/ducks/auth'
import { receiveFilter, receiveSessions, requestSessions } from 'src/ducks/liveSession'
import { Loader } from '../../shared/Loader'
import { SessionCardItem } from '../SessionCardItem'

export interface SessionType {
  id: number
  category: string
  startTime: string
  endTime: string
  startAt: string
  endAt: string
  title: string
  description: string
  date: string
  day: string
  streamUrl: string
  hasPlayback: boolean
  aboutHtml: string
  hasAccess: boolean
  secondsTillStart: number
  durationInSeconds: number
  presenters: any
  calendar: {
    ics: string
    google: string
    office365: string
    outlook: string
    yahoo: string
  }
  ended?: boolean
  currentUser: CurrentUserType
}

export const SessionContainer = ({ currentUser }) => {
  const dispatch = useDispatch()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [filteredSessions, setFilteredSessions] = useState<Array<SessionType> | null>(null)
  const { sessions, filterBy } = useSelector((state) => state.liveSession)

  const fetchSessions = useCallback(() => {
    setPageLoading(true)
    dispatch(requestSessions())
    get(
      LIVE_SESSION_APIS.GET_SESSIONS,
      (data) => {
        setPageLoading(false)
        dispatch(receiveSessions(data.live_sessions))
        setFilteredSessions(data.live_sessions)
      },
      (error) => {
        setPageLoading(false)
        console.error(error)
      }
    )
  }, [dispatch])


  useEffect(() => {
    dispatch(receiveFilter({ type: 'date', tabText: 'Day 1', tabValue: '18 MAR' }))
  }, [])

  useEffect(() => {
    fetchSessions()
  }, [filterBy])

  useEffect(() => {
    if (filterBy['type'] === 'date') {
      setFilteredSessions(sessions.filter((ses) => ses.date === filterBy['tabValue']))
    } else if (filterBy['type'] === 'category') {
      setFilteredSessions(sessions.filter((ses) => ses.category === filterBy['tabValue']))
    } else {
      if (filterBy['tabValue'] === 'me') {
        setFilteredSessions(sessions.filter((ses) => ses.hasAccess))
      } else {
        setFilteredSessions(sessions)
      }
    }
  }, [filterBy, sessions])

  const pastSessions = filteredSessions?.filter((s) => s.durationInSeconds + s.secondsTillStart < 0)
  const upcomingSessions = filteredSessions?.filter((s) => s.durationInSeconds + s.secondsTillStart >= 0)

  return (
    <Loader fullPage loading={pageLoading}>
      <div className="agenda-grid">
        {upcomingSessions?.map((session) => (
          <SessionCardItem currentUser={currentUser} key={session.id} {...session} />
        ))}
        {pastSessions?.map((session) => (
          <SessionCardItem currentUser={currentUser} ended key={session.id} {...session} />
        ))}
      </div>
    </Loader>
  )
}